// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';  // ✅
import { AuthContextProvider } from './context/AuthContext';

import DynamicRoutes from './components/DynamicRoutes';                    // ← your router
import './index.css';

/* ────────────────────────────────────────────────────────────── */
/* 1️⃣  One shared client for the whole application              */
const queryClient = new QueryClient();
/* ────────────────────────────────────────────────────────────── */

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

createRoot(container).render(
  <React.StrictMode>
    {/* 2️⃣  Make React-Query available to EVERY component */}
    <QueryClientProvider client={queryClient}>
      {/* 3️⃣  Normal routing & auth context */}
      <BrowserRouter>
        <AuthContextProvider>
          <DynamicRoutes />          {/* or <AppRoutes /> if you prefer */}
        </AuthContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
